import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.halloween,
    props.app.modal_halloween,
    props.app.modal_halloween_data,
    props.app.buttons.halloween,
    (halloween, modal, modal_data, button) => {
        return {
            halloween,
            modal,
            modal_data,
            button
        }
    }
)